import oro from 'images/brands-unique/cds/tier-oro.webp';
import platino from 'images/brands-unique/cds/tier-platino.webp';
import diamante from 'images/brands-unique/cds/tier-diamante.webp';

export default { oro, platino, diamante };
